import { getBusinessSequences } from '@/services/sequencesService';
import { useQuery } from '@tanstack/react-query';

type UseQueryBusinessSequenceProps = {
	businessId: string;
	enabled?: boolean;
};

export const useQueryBusinessSequence = ({
	businessId,
	enabled = true
}: UseQueryBusinessSequenceProps) => {
	return useQuery({
		queryKey: ['business-sequences-data', businessId],
		queryFn: () => getBusinessSequences(businessId),
		enabled
	});
};
